// extracted by mini-css-extract-plugin
export var wrapper = "footer-module--wrapper--7Flzi";
export var contactWrapper = "footer-module--contactWrapper--3UsBU";
export var twitterWrapper = "footer-module--twitterWrapper--31VyB";
export var emailWrapper = "footer-module--emailWrapper--28kYp";
export var copyright = "footer-module--copyright--3yIxz";